import { render, staticRenderFns } from "./BikeLockInstructions.vue?vue&type=template&id=20a905fa&lang=pug&"
import script from "./BikeLockInstructions.vue?vue&type=script&lang=ts&"
export * from "./BikeLockInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./BikeLockInstructions.vue?vue&type=style&index=0&id=20a905fa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports